import { IndexableObject } from '../types/ObjectTypes';
import objectFilter from './objectFilter';

/**
 * @param {Object} object - object to run filters on
 * @param {String|String[]} filters - property name or names to include
 */
const pick = (
  object: IndexableObject,
  ...filters: Array<string | Array<string>>
): IndexableObject => objectFilter(object, true, ...filters);

export default pick;
